import React, { useEffect } from "react"; // Import useEffect
import "../styles/AboutSection.css"; // Pastikan CSS ini ada
import product1 from "../assets/product4.jpeg"; // Asumsi ini gambar Sensor Ultrasonik
import product2 from "../assets/product2.jpg"; // Asumsi ini gambar Flow Sensor
import product3 from "../assets/product3.jpg"; // Asumsi ini gambar CCTV Camera
import product4 from "../assets/product1.jpg"; // Asumsi ini gambar Mikrokontroler
import product5 from "../assets/product5.jpg"; // Asumsi ini gambar GPS Ublox
import product6 from "../assets/product6.jpeg"; // Asumsi ini gambar Sensor Kualitas Air

const AboutSection = () => {
    // useEffect untuk memuat skrip TikTok embed
    useEffect(() => {
        const script = document.createElement('script');
        script.src = "https://www.tiktok.com/embed.js";
        script.async = true;
        script.id = "tiktok-embed-script"; // Memberi ID untuk menghindari duplikasi

        // Memastikan skrip hanya dimuat sekali
        if (!document.getElementById(script.id)) {
            document.body.appendChild(script);
        }

        // Cleanup function (opsional, tergantung kebutuhan)
        // return () => {
        //     const existingScript = document.getElementById(script.id);
        //     if (existingScript) {
        //         document.body.removeChild(existingScript);
        //     }
        // };
    }, []); // Array dependensi kosong agar hanya berjalan sekali saat mount

    // HTML untuk embed TikTok, menggunakan dangerouslySetInnerHTML
    const tiktokEmbedHtml = `
        <blockquote class="tiktok-embed" cite="https://www.tiktok.com/@depot.air.cerdas/video/7516405695349050631" data-video-id="7516405695349050631" style="max-width: 605px;min-width: 325px;" >
            <section>
                <a target="_blank" title="@depot.air.cerdas" href="https://www.tiktok.com/@depot.air.cerdas?refer=embed">@depot.air.cerdas</a> BOS DEPOT WAJIB PUNYA INI! Monitoring galon otomatis ➔ Sensor air + aplikasi ➔ Ga perlu catat manual lagi  Pantau pengisian, stok tangki, transaksi, & omzet langsung di HP   #DepotAirCerdas <a title="depotair" target="_blank" href="https://www.tiktok.com/tag/depotair?refer=embed">#depotair</a><a title="depotairminum" target="_blank" href="https://www.tiktok.com/tag/depotairminum?refer=embed">#depotairminum</a> <a target="_blank" title="♬ suara asli  - Depot Air Cerdas" href="https://www.tiktok.com/music/suara-asli-Depot-Air-Cerdas-7516405787309263632?refer=embed">♬ suara asli  - Depot Air Cerdas</a>
            </section>
        </blockquote>
    `;

    return (
        <section id="about" className="about-section">
            {/* Bagian Perkenalan & Solusi Kami (Tidak Berubah) */}
            <div className="section-intro-container">
                <h2 className="section-title">Kenalan Lebih Dekat dengan Depot Air Cerdas</h2>
                <p className="intro-text">
                    Di zaman sekarang, teknologi itu bukan cuma buat gadget canggih, tapi juga bisa bantu banget usaha depot air minum Anda. **Depot Air Cerdas** hadir sebagai solusi pintar berbasis IoT yang bikin operasional Anda jadi lebih gampang, aman, dan pastinya untung makin berlipat! Kami bantu Anda memantau semuanya secara *real-time* dari genggaman tangan.
                </p>
            </div>

            {/* Apa itu IoT untuk Depot Air? (Tidak Berubah) */}
            <div className="about-card-group">
                <div className="about-card">
                    <h3 className="card-title">IoT Itu Apa Sih, Buat Depot Air?</h3>
                    <p className="card-description">
                        **Internet of Things (IoT)** itu gampangnya gini: alat-alat biasa di depot Anda (sensor air, alat catat galon) bisa terhubung ke internet. Mereka lalu ngobrol satu sama lain dan kirim data langsung ke ponsel atau laptop Anda. Jadi, Anda bisa mantau stok air, jumlah galon yang keluar masuk, sampai proses pengiriman secara otomatis, tanpa harus bolak-balik ngecek ke lokasi. Lebih praktis, kan?
                    </p>
                </div>
                <div className="about-card">
                    <h3 className="card-title">Depot Air Cerdas: Sahabat Usaha Anda</h3>
                    <p className="card-description">
                        **Depot Air Cerdas** dirancang khusus untuk para pemilik depot air minum seperti Anda. Sistem kami punya banyak fitur andalan: mencatat setiap tetes air yang keluar dari galon, melacak posisi motor pengantar dengan GPS, dan menyajikan semua data penjualan harian, mingguan, bahkan bulanan dalam laporan yang gampang dibaca. Anda jadi bisa tidur nyenyak, tahu semua beres terkontrol!
                    </p>
                </div>
            </div>

            {/* Bagian Masalah Umum Pemilik Depot (Tidak Berubah) */}
            <div className="problems-section">
                <h2 className="section-title">Pusingnya Pemilik Depot Air: Masalah Klasik yang Sering Bikin Rugi</h2>
                <p className="intro-text">
                    Kami tahu, jadi pemilik depot air itu gak gampang. Ada saja tantangannya, apalagi soal **kecurangan** yang sering bikin kantong bolong. Pernah ngalamin masalah ini?
                </p>
                <ul className="problem-list">
                    <li>Galon yang terjual kok angkanya beda sama yang dicatat? Atau bahkan ada yang 'hilang' begitu saja.</li>
                    <li>Stok air di tandon tiba-tiba berkurang drastis tanpa ada laporan yang jelas, bikin kaget pas mau isi ulang.</li>
                    <li>Motor pengantar galon sering keluar jalur atau mampir ke mana-mana, bikin pengiriman jadi lama dan bensin boros.</li>
                    <li>Karyawan yang 'main mata', bikin laporan penjualan jadi tidak transparan dan Anda jadi rugi diam-diam.</li>
                </ul>
                <p className="intro-text-small">
                    Tanpa sistem pengawasan yang canggih, keuntungan bisa bocor ke mana-mana dan Anda jadi sulit mengendalikan usaha dengan efisien. Jangan sampai ini terus-terusan terjadi!
                </p>
            </div>

            {/* Solusi Cerdas Kami dengan Teknologi (Tidak Berubah) */}
            <div className="solution-section">
                <h2 className="section-title">Solusi Jitu Depot Air Cerdas: Anti-Curang, Makin Untung!</h2>
                <p className="intro-text">
                    Jangan khawatir, kami punya solusinya! **Depot Air Cerdas** adalah jawaban atas keresahan Anda. Sistem berbasis IoT kami hadir dengan sederet teknologi andalan untuk mengatasi semua masalah tadi:
                </p>
                <div className="solution-features-grid">
                    <div className="solution-feature-item">
                        <h3 className="feature-title">Pantau Stok Air Real-time</h3>
                        <p className="feature-description">Sensor pintar kami akan kasih tahu Anda volume air yang tersisa di tandon. Kalau mau habis, langsung ada notifikasi. Isi ulang pun jadi pas waktu, pelanggan gak perlu nunggu kelamaan!</p>
                    </div>
                    <div className="solution-feature-item">
                        <h3 className="feature-title">Catat Galon Otomatis & Akurat</h3>
                        <p className="feature-description">Setiap galon yang keluar dari depot akan tercatat otomatis. Gak ada lagi cerita galon 'hilang' atau penjualan yang tidak sesuai. Transaksi jadi transparan 100%!</p>
                    </div>
                    <div className="solution-feature-item">
                        <h3 className="feature-title">Aktivitas Depot Aman Terpantau CCTV</h3>
                        <p className="feature-description">Kamera CCTV terhubung ke sistem kami. Anda bisa melihat semua aktivitas di depot dari mana saja. Kecurangan karyawan atau hal-hal mencurigakan? Langsung ketahuan!</p>
                    </div>
                    <div className="solution-feature-item">
                        <h3 className="feature-title">Lacak Pengiriman dengan GPS Motor</h3>
                        <p className="feature-description">Pasang alat GPS di motor pengantar galon. Anda bisa tahu persis lokasi motor, rute yang dilewati, dan memastikan pengiriman tepat waktu. Gak ada lagi motor 'ngilang' atau boros bensin karena muter-muter!</p>
                    </div>
                </div>
            </div>

            {/* Galeri Produk & Cara Kerja (Tidak Berubah) */}
            <div className="product-gallery-section">
                <h2 className="section-title">Lihat Lebih Dekat Alat Kami dan Bagaimana Mereka Bekerja!</h2>
                <p className="intro-text">
                    Penasaran seperti apa sih wujud teknologi yang bikin depot Anda makin cerdas? Ini dia beberapa alat andalan kami, yang bekerja sama untuk mempermudah hidup Anda:
                </p>
                <div className="product-gallery-grid">
                    {/* Produk 1: Sensor Ultrasonik JSN-SR04T */}
                    <div className="product-card-item">
                        <img src={product1} alt="Sensor Ultrasonik JSN-SR04T Pemantau Air Tandon" className="product-image" />
                        <h3 className="product-name">Sensor Ultrasonik JSN-SR04T</h3>
                        <p className="product-desc">Alat ajaib ini dipasang di tandon air Anda. Dia pakai gelombang suara buat ngukur ketinggian air. Data ketinggian itu lalu dihitung otomatis jadi volume air yang akurat di tandon, biar Anda tahu kapan harus isi ulang!</p>
                    </div>
                    
                    {/* Produk 2: Mikrokontroler (Otak Sistem) */}
                    <div className="product-card-item">
                        <img src={product4} alt="Mikrokontroler Otak Sistem Depot Air Cerdas" className="product-image" />
                        <h3 className="product-name">Mikrokontroler: Otak Sistem Kami</h3>
                        <p className="product-desc">Inilah otak di balik semua kecerdasan Depot Air Cerdas! Mikrokontroler ini yang menerima data dari sensor-sensor (seperti ketinggian air atau galon keluar), memprosesnya, dan kemudian mengirimkannya ke aplikasi Anda secara *real-time*. Dia juga yang mengatur semua komunikasi antar alat dan server.</p>
                    </div>

                    {/* Produk 3: Sensor Flow Meter Galon Otomatis */}
                    <div className="product-card-item">
                        <img src={product2} alt="Sensor Flow Meter Pencatat Galon Otomatis" className="product-image" />
                        <h3 className="product-name">Sensor Flow Meter Galon Otomatis</h3>
                        <p className="product-desc">Alat canggih ini dipasang di jalur pengisian galon. Setiap kali galon terisi, sensor ini langsung mencatatnya. Data penjualan masuk otomatis ke sistem, memastikan setiap tetes air terjual tercatat akurat dan tanpa manipulasi!</p>
                    </div>

                    {/* Produk 4: GPS Ublox (Pelacak Perjalanan) */}
                    <div className="product-card-item">
                        <img src={product5} alt="GPS Ublox Pelacak Perjalanan Pengiriman" className="product-image" />
                        <h3 className="product-name">GPS Ublox: Pelacak Perjalanan</h3>
                        <p className="product-desc">Pasang modul GPS ini di kendaraan pengantar galon Anda. Dengan teknologi Ublox yang presisi, Anda bisa tahu persis lokasi motor atau mobil pengantar secara *live*. Pantau rute, pastikan pengiriman lancar, dan hindari pemborosan waktu atau bensin yang tidak perlu.</p>
                    </div>
                    
                    {/* Produk 5: Kamera CCTV Pengawas Depot */}
                    <div className="product-card-item">
                        <img src={product3} alt="Kamera CCTV Pengawas Depot Air" className="product-image" />
                        <h3 className="product-name">Kamera CCTV Pengawas Depot</h3>
                        <p className="product-desc">Pantau seluruh area depot Anda 24 jam non-stop dari mana saja. Rekam aktivitas, pastikan keamanan, dan deteksi dini hal mencurigakan. Usaha Anda jadi lebih aman dan nyaman!</p>
                    </div>

                    {/* Produk Baru: Sensor Kualitas Air */}
                    <div className="product-card-item">
                        <img src={product6} alt="Sensor Kualitas Air (Suhu, pH, TDS, Garam, Kekeruhan)" className="product-image" />
                        <h3 className="product-name">Sensor Kualitas Air Multi-Parameter</h3>
                        <p className="product-desc">
                            Untuk memastikan air minum di depot Anda selalu berkualitas prima, kami menyediakan sensor khusus yang bisa mengukur sekaligus:
                            **Suhu**, **pH**, **TDS (Total Padatan Terlarut)**, **Kadar Garam**, dan **Kekeruhan** air.
                            Semua data kualitas air ini bisa Anda pantau langsung di aplikasi. Jaminan air bersih dan sehat untuk pelanggan Anda!
                        </p>
                    </div>

                </div>
            </div>

            {/* Video Testimoni & Cara Kerja (Tidak Berubah) */}
            <div className="video-section">
                <h2 className="section-title">Dengar Langsung Kisah Sukses Pengguna Kami & Tutorial Alat!</h2>
                <p className="intro-text">
                    Tak kenal maka tak sayang, tak pakai maka tak untung! Yuk, lihat sendiri bagaimana para pemilik depot air lain sudah merasakan manfaatnya, dan intip juga demo singkat cara kerja alat-alat Depot Air Cerdas!
                </p>
                <div className="video-wrapper">
                    <iframe 
                        className="responsive-iframe"
                        src="https://www.youtube.com/embed/tJr83veQ6vw" /* LINK YOUTUBE TETAP - Asumsi ini sudah benar untuk testimoni */
                        title="Testimoni dan Cara Kerja Depot Air Cerdas"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        referrerPolicy="strict-origin-when-cross-origin"> {/* Menambahkan referrerpolicy */}
                    </iframe>
                </div>
            </div>

            {/* BAGIAN BARU: Video Demo Aplikasi Web & Mobile */}
            <div className="app-demo-videos-section video-section">
                <h2 className="section-title">Lihat Langsung Tampilan Aplikasi Depot Air Cerdas Kami!</h2>
                <p className="intro-text">
                    Penasaran seperti apa sih dashboard web dan aplikasi mobile yang bisa Anda gunakan? Yuk, intip demo singkat berikut ini untuk melihat langsung kemudahan memantau depot Anda dari mana saja!
                </p>
                <div className="app-demo-grid">
                    <div className="app-video-item">
                        <h3 className="video-subtitle">Demo Aplikasi Web</h3>
                        <div className="video-wrapper">
                            <iframe 
                                className="responsive-iframe"
                                src="https://www.youtube.com/embed/RT5oa1EHWsw?si=jTi4JFq92KsDWci_" /* URL Video Aplikasi Web */
                                title="Demo Aplikasi Web Depot Air Cerdas"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowFullScreen
                                referrerPolicy="strict-origin-when-cross-origin"> {/* Menambahkan referrerpolicy */}
                            </iframe>
                        </div>
                    </div>
                    <div className="app-video-item">
                        <h3 className="video-subtitle">Demo Aplikasi Mobile</h3>
                        <div className="video-wrapper">
                            {/* TikTok Embed menggunakan dangerouslySetInnerHTML */}
                            <div dangerouslySetInnerHTML={{ __html: tiktokEmbedHtml }} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutSection;